// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer_container {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 1rem 2rem;
  padding-top: 1.75rem;
  padding-bottom: 1.5rem;
  background-color: black;
  color: white;
}

.footer_section_container h3 {
  margin-bottom: 0.8rem;
  font-weight: bold;
}

.footer_section_container ul {
  padding-left: 0;
  display: flex;
  flex-direction: column;
}

.footer_section_link {
  height: 1.2rem;
  margin-bottom: 0.4rem;
  cursor: pointer;
  color: white;
  text-decoration: none;
  font-weight: 300;
}

.footer_section_link:hover {
  text-decoration: underline;
}

.footer_section_link img {
  margin-left: 0.2rem;
}

.social_media_icon {
  height: 1.3rem;
}

.unclickable {
  cursor: wait !important;
}

.social_media_link {
  position: relative;
  display: flex;
  color: white;
}

.social_media_link_tooltip {
  visibility: hidden;
  text-align: center;
  width: 7rem;
  position: absolute;
  z-index: 1;
  border-radius: 4px;
  border: solid rgb(196, 196, 196);
  background-color: rgb(196, 196, 196);
  opacity: 0;
  transform: opacity 0.4s;
}

.social_media_link_tooltip::after {
  content: "";
  position: absolute;
  left: 100%;
}

.social_media_link:hover .social_media_link_tooltip {
  visibility: visible;
  opacity: 1;
}

.email_link {
  position: relative;
  display: inline-block;
  color: white;
  text-decoration: none;
  font-weight: 300;
}

.email_link_tooltip {
  visibility: hidden;
  text-align: center;
  width: 12.6rem;
  position: absolute;
  z-index: 1;
  left: 0;
  border-radius: 4px;
  border: solid rgb(196, 196, 196);
  background-color: rgb(196, 196, 196);
  opacity: 0;
  transform: opacity 0.4s;
  margin: auto;
}

.email_link_tooltip::after {
  content: "";
  position: absolute;
  left: 100%;
}

.email_link:hover {
  text-decoration: underline;
}

.email_link:hover .email_link_tooltip {
  opacity: 1;
}

.phone_link {
  position: relative;
  display: inline-block;
  color: white;
  text-decoration: none;
  font-weight: 300;
}

.phone_link_tooltip {
  visibility: hidden;
  text-align: center;
  width: 8rem;
  position: absolute;
  z-index: 1;
  left: 0;
  border-radius: 4px;
  border: solid rgb(196, 196, 196);
  background-color: rgb(196, 196, 196);
  opacity: 0;
  transform: opacity 0.4s;
  margin: auto;
}

.phone_link_tooltip::after {
  content: "";
  position: absolute;
  left: 100%;
}

.phone_link:hover {
  text-decoration: underline;
}

.phone_link:hover .phone_link_tooltip {
  visibility: visible;
  opacity: 1;
}

@media only screen and (max-width: 768px) {
  #footer_container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 1.3rem;
    grid-row-gap: 0.75rem;
    padding: 1rem 0;
    padding-right: 0.5rem;
    padding-top: 1.5rem;
    color: white;
    padding-bottom: 1.5rem;
  }

  .footer_section_container {
    text-align: center;
  }

  .social_media_link {
    text-align: center;
    justify-content: center;
  }

  .footer_section_container h3 {
    font-size: 1rem;
    font-weight: bold;
    color: white;
    margin: 0.2rem 0;
    margin-bottom: 0.7rem;
  }

  .footer_section_container:nth-child(3) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer_section_container:last-child {
    grid-column: 3;
  }

  .footer_section_link {
    font-size: 0.95rem;
    height: 1rem;
    margin-bottom: 0.4rem;
    cursor: pointer;
    /* color: rgb(94, 94, 94); */
    color: white;
    text-decoration: none;
  }

  .phone_link {
    font-size: 0.95rem;
  }

  .email_link {
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/footer/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;IACb,kCAAkC;IAClC,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,4BAA4B;IAC5B,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["#footer_container {\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  padding: 1rem 2rem;\n  padding-top: 1.75rem;\n  padding-bottom: 1.5rem;\n  background-color: black;\n  color: white;\n}\n\n.footer_section_container h3 {\n  margin-bottom: 0.8rem;\n  font-weight: bold;\n}\n\n.footer_section_container ul {\n  padding-left: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.footer_section_link {\n  height: 1.2rem;\n  margin-bottom: 0.4rem;\n  cursor: pointer;\n  color: white;\n  text-decoration: none;\n  font-weight: 300;\n}\n\n.footer_section_link:hover {\n  text-decoration: underline;\n}\n\n.footer_section_link img {\n  margin-left: 0.2rem;\n}\n\n.social_media_icon {\n  height: 1.3rem;\n}\n\n.unclickable {\n  cursor: wait !important;\n}\n\n.social_media_link {\n  position: relative;\n  display: flex;\n  color: white;\n}\n\n.social_media_link_tooltip {\n  visibility: hidden;\n  text-align: center;\n  width: 7rem;\n  position: absolute;\n  z-index: 1;\n  border-radius: 4px;\n  border: solid rgb(196, 196, 196);\n  background-color: rgb(196, 196, 196);\n  opacity: 0;\n  transform: opacity 0.4s;\n}\n\n.social_media_link_tooltip::after {\n  content: \"\";\n  position: absolute;\n  left: 100%;\n}\n\n.social_media_link:hover .social_media_link_tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.email_link {\n  position: relative;\n  display: inline-block;\n  color: white;\n  text-decoration: none;\n  font-weight: 300;\n}\n\n.email_link_tooltip {\n  visibility: hidden;\n  text-align: center;\n  width: 12.6rem;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  border-radius: 4px;\n  border: solid rgb(196, 196, 196);\n  background-color: rgb(196, 196, 196);\n  opacity: 0;\n  transform: opacity 0.4s;\n  margin: auto;\n}\n\n.email_link_tooltip::after {\n  content: \"\";\n  position: absolute;\n  left: 100%;\n}\n\n.email_link:hover {\n  text-decoration: underline;\n}\n\n.email_link:hover .email_link_tooltip {\n  opacity: 1;\n}\n\n.phone_link {\n  position: relative;\n  display: inline-block;\n  color: white;\n  text-decoration: none;\n  font-weight: 300;\n}\n\n.phone_link_tooltip {\n  visibility: hidden;\n  text-align: center;\n  width: 8rem;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  border-radius: 4px;\n  border: solid rgb(196, 196, 196);\n  background-color: rgb(196, 196, 196);\n  opacity: 0;\n  transform: opacity 0.4s;\n  margin: auto;\n}\n\n.phone_link_tooltip::after {\n  content: \"\";\n  position: absolute;\n  left: 100%;\n}\n\n.phone_link:hover {\n  text-decoration: underline;\n}\n\n.phone_link:hover .phone_link_tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n@media only screen and (max-width: 768px) {\n  #footer_container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: auto;\n    grid-column-gap: 1.3rem;\n    grid-row-gap: 0.75rem;\n    padding: 1rem 0;\n    padding-right: 0.5rem;\n    padding-top: 1.5rem;\n    color: white;\n    padding-bottom: 1.5rem;\n  }\n\n  .footer_section_container {\n    text-align: center;\n  }\n\n  .social_media_link {\n    text-align: center;\n    justify-content: center;\n  }\n\n  .footer_section_container h3 {\n    font-size: 1rem;\n    font-weight: bold;\n    color: white;\n    margin: 0.2rem 0;\n    margin-bottom: 0.7rem;\n  }\n\n  .footer_section_container:nth-child(3) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .footer_section_container:last-child {\n    grid-column: 3;\n  }\n\n  .footer_section_link {\n    font-size: 0.95rem;\n    height: 1rem;\n    margin-bottom: 0.4rem;\n    cursor: pointer;\n    /* color: rgb(94, 94, 94); */\n    color: white;\n    text-decoration: none;\n  }\n\n  .phone_link {\n    font-size: 0.95rem;\n  }\n\n  .email_link {\n    font-size: 0.95rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
